import { Link } from "react-router-dom";
import { ContributorProfile, Profile } from "@app/types/Cue";
import { textToSlug } from "@app/util/helpers";
import cx from "classnames";

type BylineNameProps = {
  profile: Profile | ContributorProfile;
  isLast?: boolean;
  rootClassName?: string;
  linkClassName?: string;
};

export default function BylineName({
  profile,
  isLast = false,
  rootClassName,
  linkClassName,
}: BylineNameProps): React.ReactElement {
  const authorName = profile.content.fields.name;

  return (
    <h4
      className={cx(rootClassName, {
        "mr-1.5": !isLast,
      })}
    >
      <Link
        to={`/authors/${textToSlug(authorName)}`}
        className={cx("text-base !text-black hover:underline", linkClassName)}
        target="_blank"
        reloadDocument
      >
        {`${authorName}${!isLast ? ", " : ""}`}
      </Link>
    </h4>
  );
}
